import React, { useState, useEffect } from "react";
import axios from "axios";
import swal from "sweetalert";
import InputField from "../inputComponents/InputField";
import SelectField from "../inputComponents/SelectField";
import FileUpload from "../appComponents/FileUpload";
import Loading from "../../childComponents/appComponents/Loading";
/* For Image Crop */
import Crop from "../appComponents/Crop";
import CropRatio from "../appComponents/CropRatio";
/* End of For Image Crop */

const ModalGal = (props) => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const ADMINNAME = localStorage.getItem("auth_name");
  const BUTTON_NAME = "POST GALLERY"; // Submit Button Name
  const getTodayDate = () => {
    return new Date().toISOString().split("T")[0];
  };

  //Fetches all Form Data
  const [allformData, setAllFormData] = useState({
    input: {
      galleryTithle: null,
      caption: null,
      status02: null,
      dater: getTodayDate(), // ✅ default today
    },
  });

  const [reloadState, setReloadState] = useState({
    btnLoading: BUTTON_NAME,
    loading: true,
  });

  /* For Image Crop */
  const [returnRatio, setReturnRatio] = useState("");
  const [returnCrop, setReturnCrop] = useState("");
  const [cropImage, setCropImage] = useState("");
  const [actionType, setActionType] = useState("");
  const [allPics, setAllPics] = useState([]);
  const [closeModal, setCloseModal] = useState(false);
  const [isNewImage, setIsNewImage] = useState(false);
  const [requireCrop, setRequireCrop] = useState(false);
  /* End of For Image Crop */

  const [returnUpload, setReturnUpload] = useState("");
  const [returnUploads, setReturnUploads] = useState("");

  // Function to update form data dynamically
  const updateFormData = (type, key, value) => {
    setAllFormData((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [key]: value,
      },
    }));
  };
  //replaces each first character of a word with its uppercase version
  function ucwords(str) {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  }

  useEffect(() => {
    setReturnRatio("Photo News");
    setAllFormData((prev) => ({
      ...prev,
      input: {
        galleryTithle: props.editposts.galleryTithle,
        caption: props.editposts.caption,
        status02: props.editposts.status02,
        dater: props.editposts.datesd || getTodayDate(),
      },
    }));
    const fetchGalleryPics = async () => {
      try {
        await axios.get("sanctum/csrf-cookie");
        const info = "UseThis";

        const res = await axios.get(
          `${BASE_URL}galdataAdmin?trackerf[eq]=${props.editposts.trackerf}`,
        );

        console.log("###SSS", res.data.allData);
        if (res?.data?.status === 200) {
          setAllPics(res.data.allData);
        }
      } catch (error) {
        swal("Error", "Error fetching Gallery Data", "error");
        console.log(error);
      }
    };

    fetchGalleryPics();
    
    setReloadState((prev) => ({
      ...prev,
      btnLoading: props.modalTitle,
      loading: false,
    }));


    //(async () => await populateSelectMenu())();
  }, [props.editposts, props.modalTitle]);

  async function submitUpload(event) {
    event.preventDefault();

    setReloadState((prev) => ({
      ...prev,
      btnLoading: <div>Processsing...</div>,
      loading: true,
    }));

    // ❌ BLOCK if new image selected but NOT cropped
    if (requireCrop) {
      return swal(
        "Crop Required",
        "Please crop the selected image before submitting.",
        "warning",
      );
    }
    let urlpost;

    if (props.modalTitle === "POST GALLERY") {
      urlpost = `${BASE_URL}galdata`;
    } else {
      urlpost = `${BASE_URL}galdata/update`;
    }

    if (!returnUpload.myFile) {
      console.log("No file Selected");
      return swal(
        "Caution",
        "Please select a file or image to upload",
        "warning",
      );
    }

    let fileUploadItems = returnUploads.myFile;

    let fileType = 1;

    if (returnCrop) {
      fileType = 2;
    }

    let formData;

    formData = new FormData();
    if (actionType === "post") {
      formData.append("action", "post");
    }
    if (actionType === "copy") {
      formData.append("action", "copy");
    }
    formData.append("pic", returnCrop ? returnCrop : returnUpload.myFile[0]); //upload
    if (fileUploadItems && fileUploadItems.length > 0) {
      fileUploadItems.forEach((file) => {
        // ONLY upload if it's a real File object
        if (file instanceof File) {
          formData.append("pics[]", file);
        }
      });
    }
    formData.append("fileType", fileType);
    formData.append("myFileUpdate", returnUpload.myFileUpdate); // We will have to delete the old image / file after uploading the new upload

    formData.append("galleryTithle", ucwords(allformData.input.galleryTithle)); // Office
    formData.append("caption", ucwords(allformData.input.caption)); // Persons Name

    formData.append("dater", allformData.input.dater);

    formData.append("status02", allformData.input.status02);
    formData.append("staff", ADMINNAME);
    formData.append("id", props.editposts.id);
    formData.append("trackerf", props.editposts.trackerf);

    await axios.get(`sanctum/csrf-cookie`).then((response) => {
      try {
        axios.post(urlpost, formData).then((res) => {
          if (res?.data?.status === 200) {
            swal("Success", res.data.message, "success");
            setReloadState({
              btnLoading: props.modalTitle,
              loading: false,
            });
            props.formCleanners();
            props.setCloseModal(true);
          } else {
            swal("Oops!", res.data.message, "error");
          }
        });
      } catch (error) {
        swal("Oops!", "Failed", "error");
        console.log(error.response.data);
      }
    });
  }
  const galleryPics = React.useMemo(() => {
    return allPics.map((item) => item.pic);
  }, [allPics]);

  if (reloadState.loading) {
    return <Loading message01={"Loading..."} />;
  }

  return (
    <>
      {closeModal ? (
        <Crop
          imageCropUrl={cropImage}
          setReturnCrop={setReturnCrop}
          returnRatio={returnRatio}
          setCloseModal={setCloseModal}
        />
      ) : null}
      <form onSubmit={submitUpload} encType="multipart/form-data">
        <div className="row">
          <div className="col-md-9 mb-3">
            <div className="card">
              <div
                className={`card-header text-white bg-${props.btnColors} p-3`}
              >
                <i className="fa fa-newspaper"></i> {props.modalTitle}
              </div>
              <div className="card-body">
                <div className="row m-1">
                  <InputField
                    label="Gallery Title"
                    name="galleryTithle"
                    size="6"
                    placeholder="Please Type in a Title"
                    required="required"
                    value={allformData.input.galleryTithle}
                    type="text"
                    onChange={updateFormData}
                    icon="fa fa-file-text"
                  />

                  <InputField
                    label="Caption"
                    name="caption"
                    size="6"
                    placeholder="Please Type in a Caption"
                    required="required"
                    value={allformData.input.caption}
                    type="text"
                    onChange={updateFormData}
                    icon="fa fa-file-text"
                  />

                  <InputField
                    label="Start Date"
                    name="dater"
                    size="6"
                    placeholder="Please Select Start Date"
                    required="required"
                    value={allformData.input.dater}
                    type="date"
                    onChange={updateFormData}
                    icon="fa fa-calendar-check-o"
                  />

                  <div className="col-lg-6 p-4 row">
                    <InputField
                      label="Save As Draft"
                      size="8"
                      name="status02"
                      type="checkbox"
                      checked={allformData.input.status02 === "draft"}
                      value="draft"
                      onChange={updateFormData}
                    />

                    <InputField
                      label="Publish"
                      size="4"
                      name="status02"
                      type="checkbox"
                      checked={allformData.input.status02 === "publish"}
                      value="publish"
                      onChange={updateFormData}
                    />
                  </div>
                  <div className="row m-1">
                    <div className="col-lg-12 ps-4">
                      <div className="form-group mt-2">
                        <button
                          disabled={isNewImage && !returnCrop}
                          className={`btn btn-${props.btnColors} col-lg-12 mt-4`}
                          onClick={() => setActionType("post")}
                        >
                          <div className="d-flex align-items-center justify-content-center w-100">
                            <i className="fa fa-edit m-1"></i>
                            <span>{reloadState.btnLoading}</span>
                          </div>
                        </button>
                      </div>
                    </div>
                    {/* <div className="col-lg-6 ps-4">
                      <div className="form-group mt-2">
                        <button
                          className={`btn btn-secondary col-lg-12 mt-4`}
                          onClick={() => setActionType("copy")}
                        >
                          <div className="d-flex align-items-center justify-content-center w-100">
                            <i className="fa fa-clone m-1"></i>
                            <span>COPY POST</span>
                          </div>
                        </button>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-3 mb-3">
            {/* {tagName} */}
            {/* send data to be displayed, collect processed result for the parent componet*/}
            <FileUpload
              editposts={props.editposts.pic}
              setReturnUpload={(data) => {
                setReturnUpload(data);

                // 🔥 THIS IS WHERE IT GOES
                if (data?.myFile?.[0] instanceof File) {
                  setIsNewImage(true);

                  // open crop modal
                  setCropImage(data.myFileUrl?.[0]);
                  setCloseModal(true);
                }
              }}
              maxFiles={1}
              titileHead={"POTO NEWS UPLOAD"}
            />
            <CropRatio
              setCloseModal={setCloseModal}
              setCropImage={setCropImage}
              returnUploader={returnUpload.myFileUrl?.[0]}
              setReturnRatio={setReturnRatio}
              defaultRatio={returnRatio}
              defaultSize={"Photo News"}
              setRequireCrop={setRequireCrop}
            />
          </div>

          <div className="col-md-12 mb-3">
            {/* {tagName} */}
            {/* send data to be displayed, collect processed result for the parent componet*/}
            <FileUpload
              editposts={galleryPics} // ✅ stable reference
              existingOnly={true}
              setReturnUpload={setReturnUploads}
              maxFiles={40}
              titileHead={"GALLERY UPLOADS (Max 40 Pictures)"}
            />
          </div>
        </div>
      </form>
    </>
  );
};
export default ModalGal;
